import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { DriverSuspensionService } from '@uzurv/clara';
import { UzurvDirectivesModule, UzurvPipesModule } from '@uzurv/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NewDriverSuspensionDialogComponent } from './new-driver-suspension-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSelectModule,
    MatIconModule,
    MatDatepickerModule,
    MatRadioModule,
    FormsModule,
    UzurvPipesModule,
    NgxMatSelectSearchModule,
    FormsModule,
    UzurvDirectivesModule
  ],
  declarations: [NewDriverSuspensionDialogComponent],
  exports: [NewDriverSuspensionDialogComponent],
  providers: [DriverSuspensionService]
})
export class NewDriverSuspensionsDialogModule {}
